import { render } from "./DocumentMappingView.vue?vue&type=template&id=ae49df10&ts=true"
import script from "./DocumentMappingView.vue?vue&type=script&lang=ts"
export * from "./DocumentMappingView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__